// const baseUrl = "https://ivoapi.vinnisoft.com/";
const baseUrl = "https://ivodev.vinnisoft.org/";
// const baseUrl = "http://192.168.1.24:8004/";
const endPointUrl = baseUrl + "api";

const constants = { baseUrl, endPointUrl };

export default constants;
